import { useForm } from 'react-hook-form';
import Button from '../../Reusable/Button';
import Modal from '../../Reusable/Modal';
import TextField from '../../Reusable/TextInput';
// @ts-ignore
import { tw } from '@careinfo/tailwind';
import { yupResolver } from '@hookform/resolvers/yup';
import APIS from '../../../constant/Endpoint';
import usePostHook from '../../../customHooks/usePostHook';
import { AddSmsGroupForm } from '../../../utils/validationSchemas';
import PhoneNumberField from '../../Reusable/PhoneNumberField';

const AddSmsModal = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
    watch,
    getValues,
    clearErrors,
    control,
  } = useForm({
    resolver: yupResolver(AddSmsGroupForm),
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ['contacts'],
  });

  const handleCreate = async (values: any) => {
    const url = APIS.SENDER_SMS;
    const formData = { ...values };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setIsOpen(false);
        reset();
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} title='Add SMS'>
      <div className={tw`flex flex-col items-center w-[600px]`}>
        <form
          onSubmit={handleSubmit(handleCreate)}
          className={tw`space-y-4 mt-4 w-full`}
        >
          <div>
            <TextField
              label={
                <div className={tw`block text-sm font-medium mb-1`}>Name</div>
              }
              placeholder='Enter Name...'
              register={register('name')}
              errors={errors?.name}
            />
            <br />
            <PhoneNumberField
              control={control}
              name='recipient'
              label={'From'}
              errors={errors.recipient}
              labelWidth={100}
            />
          </div>

          <div className={tw`flex justify-center items-center gap-4 pt-2`}>
            <div className={tw`px-2 py-2 text-sm w-[100px]`}>
              <Button
                label='Cancel'
                onClick={() => setIsOpen(false)}
                variant='secondary'
                type='button'
              />
            </div>
            <div className={tw`px-2 py-2 text-sm w-[100px]`}>
              <Button label='Add' type='submit' isLoading={isPostLoading} />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddSmsModal;
